import { useSetAtom } from "jotai";

import { isNotificationsNudgeModalOpenAtom } from "../atoms/stores";

export const useOpenNudgeModalAfterCompletedBooking = (
  hasPublicSeenNotificationNudgeModal?: boolean
) => {
  const setNudgeModalOpen = useSetAtom(isNotificationsNudgeModalOpenAtom);

  const handleOpenNudgeModal = () => {
    const hasSeenModal = hasPublicSeenNotificationNudgeModal;

    if (!hasSeenModal) {
      setNudgeModalOpen(true);
    }
  };

  return handleOpenNudgeModal;
};
